import { dataConfig } from '../config/data_config';
let session = false;
let http;
let host;
let port;
let File;

/*  Environment Settings */
switch (dataConfig.environment) {
  case 'Production':
      host = dataConfig.srvMiddl.host;
      port = dataConfig.srvMiddl.port;
      File = dataConfig.filePro.url;
    break;
  case 'Testing':
      host = dataConfig.srvMiddlTest.host;
      port = dataConfig.srvMiddlTest.port;
      File = dataConfig.fileMiddle.url;
    break;
  case 'Development':
      host = dataConfig.srvMiddlDev.host;
      port = dataConfig.srvMiddlDev.port;
      File = dataConfig.fileDev.url;
    break;
}

/*  Http configuration  */
if (dataConfig.ssl) {
  http = dataConfig.https;
} else {
  http = dataConfig.http;
}

const rootURI = `${http}${host}:${port}/`;
const fileURl= File
const urls = {
  fileURl,
  rootURI,
  srvMidd: 'srv-midd',
  users: 'users',
  usrDiagnosed:'usr-get-diagnosed',
  dataSend:'data-send',
  qyrUsr: 'qry-usr',
  crtUsr: 'crt-usr',
  crtformsUsr: 'crt-forms-usr',
  getUsr: 'get-usr',
  searchtUsr: 'search-usr',
  crtPassValidation: 'crt-pass-vali',
  updUsr: 'upd-usr',
  dltUsr: 'dlt-usr',
  authUsr: 'ath-usr',
  lgutUsr: 'lgt-usr',
  customerUsr: 'customer-usr',
  sendOtpUsr: 'send-otp-usr',
  cust: 'customers',
  custPolitics:'cust-politics',
  custByDomain:'cust-by-domain',
  custById: 'cust-by-id',
  resp: 'respondents',
  params: 'parameters',
  frm: 'forms',
  crtFrm: 'crt-frm',
  getFrm: 'get-frm',
  updFrm: 'upd-frm',
  dltFrm: 'dlt-frm',
  setFrm: 'set-forms',
  crtSetFrm: 'crt-set-frm',
  getSetFrm: 'get-set-frm',
  updSetFrm: 'upd-set-frm',
  dltSetFrm: 'dlt-set-frm',
  custFrm: 'cust-forms',
  crtCustFrm: 'crt-cust-frm',
  createPeriodic: 'crt-create-pereodic',
  getCustFrm: 'get-cust-frm',
  getDtaFrmHash: 'get-dta-frm-hash',
  updCustFrm: 'upd-cust-frm',
  dltCustFrm: 'dlt-cust-frm',
  dtaFrm: 'dta-forms',
  crtDtaFrm: 'crt-dta-frm',
  sendDataBlock: 'register-transaction',
  callDataBlock: 'get-transactions-idb',
  getDtaFrm: 'get-dta-frm',
  getDtaFrmUsr: 'get-dusr-frm',
  getAllDtaFrmUsr: 'get-all-d',
  updDtaFrm: 'upd-dta-frm',
  upFileDtaFrm: 'create-pdf',
  dltDtaFrm: 'dlt-dta-frm',
  meeting: 'meeting',
  crtMeeting: 'crt-meet',
  getMeeting: 'get-meet',
  getKeyMeeting: 'get-keymeet',
  updMeeting: 'upd-meet',
  dltMeeting: 'dlt-meet',
  resMeeting: 'res-meet',
  formulas:'formulas',
  sendMailToDoctor:'send-mail-doctor',
  sendCredentialsMailUser: 'send-mail-credentials-user',
  sendNcrypt: 'send-n-crypt',
  sendDcrypt: 'send-d-crypt',
  searchUsrByCH: 'search-usr-ch'
  
};

export const globalData = {
  session,
  urls,
  allowedExt: ['pdf', 'jpg', 'jpeg', 'svg', 'png'],
  sizeFile: 5000000
}
